import { useState, useEffect } from "react";
import useProductDisplayMobility from "./useProductDisplayMobility";
import { useScrollbarWidth } from "./useScrollbarWidth";

function useDummyElementWidth(noOfProducts) {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const { width } = useProductDisplayMobility();
  const scrollBarWidth = useScrollbarWidth();
  const [result, setResult] = useState({ dummyElementWidth: NaN, rowWidth: NaN });

  useEffect(() => {
    const calculateWidths = () => {
      const gap = 10; // gap between products
      let containerWidth = 0;
      let gapPerRow = 0;

      if (document.body.clientWidth < window.innerWidth) {
        containerWidth = (windowWidth - scrollBarWidth) * 0.95;
        console.log("Hello");
      } else {
        containerWidth = windowWidth * 0.95;
      }
      gapPerRow = Math.floor((containerWidth - width) / (width + gap));

      const productsPerRow = gapPerRow + 1;
      const productsOnLastRow = noOfProducts % productsPerRow;
      const dummyProductAmount = productsPerRow - productsOnLastRow;
      const gapToDummyWidthAmount = (dummyProductAmount - 1) * gap;
      const dummyElementWidth = dummyProductAmount * width + gapToDummyWidthAmount;

      const rowWidth = (productsPerRow * width) + (gapPerRow * gap);

      setResult({ dummyElementWidth, rowWidth });
    };

    const handleResize = () => {
      setWindowWidth(window.innerWidth);
      calculateWidths();
    };

    window.addEventListener("resize", handleResize);
    calculateWidths();

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [noOfProducts, windowWidth, width, scrollBarWidth]);

  return result;
}

export default useDummyElementWidth;
